/**
 * Коды типов сущностей модели знаний, на которые опирается интерфейс.
 * Полный состав доменов заводится на стороне сервера.
 */
export const KM_ENTITY_TYPES = {
  /** Единица знания */
  NOTE: 'note',
  /** Именованный набор нод знаний */
  NOTE_SET: 'note_set',
} as const;

/** Код атрибута, значение которого служит названием экземпляра */
export const KM_NAME_ATTR_CODE = 'name';

/**
 * Типы данных значения атрибута: от них зависит и способ ввода значения, и его проверка.
 */
export const KM_ATTR_DATA_TYPES = {
  TEXT: 'TEXT',
  INT: 'INT',
  DECIMAL: 'DECIMAL',
  DATE: 'DATE',
  DATETIME: 'DATETIME',
  BOOL: 'BOOL',
  JSON: 'JSON',
  /** Выбор одного значения справочника */
  SELECT: 'SELECT',
  /** Выбор нескольких значений справочника */
  MULTISELECT: 'MULTISELECT',
  /** Значение-структура: поля по её составу */
  STRUCT: 'STRUCT',
} as const;

/**
 * Коды доменов модели знаний.
 */
export const KM_DOMAINS = {
  /** Курируемое знание */
  KNOWLEDGE: 'knowledge',
  /** Устройство оценивания */
  EVAL: 'eval',
} as const;
